import request from '@/utils/request'
import { getShopId } from '@/api/shop/shopApi'

// 获取商品订单列表
export function getStoreOrderList(params) {
  return new Promise((resolve, reject) => {
    request({
      url: '/storeOrder.queryStoreOrder',
      method: 'get',
      params: {
        ...params,
        shopId: getShopId()
      }
    }).then(response => {
      const res = response.data
      resolve(res)
    }).catch(error => {
      reject(error)
    })
  })
}

// 获取拼团订单列表
export function getProductGroupOrderList(params) {
  return new Promise((resolve, reject) => {
    request({
      url: '/productGroup.listProductGroupOrder',
      method: 'get',
      params: {
        ...params,
        shopId: getShopId()
      }
    }).then(response => {
      const res = response.data
      resolve(res)
    }).catch(error => {
      reject(error)
    })
  })
}

// 获取秒杀订单列表
export function getProductSeckillOrderList(params) {
  return new Promise((resolve, reject) => {
    request({
      url: '/productSeckill.listProductSeckillOrder',
      method: 'get',
      params: {
        ...params,
        shopId: getShopId()
      }
    }).then(response => {
      const res = response.data
      resolve(res)
    }).catch(error => {
      reject(error)
    })
  })
}

// 获取退款订单列表
export function getRefundOrderList(params) {
  return new Promise((resolve, reject) => {
    request({
      url: '/refundOrder.queryRefundOrders',
      method: 'get',
      params: {
        ...params,
        shopId: getShopId()
      }
    }).then(response => {
      const res = response.data
      resolve(res)
    }).catch(error => {
      reject(error)
    })
  })
}